import PropTypes from 'prop-types';
import React from 'react';
import Footer from './footer';
import Header from './header';

// @ts-ignore
const Layout = ({ children }) => {
  return (
    <>
      <div className="flex flex-col text-primary">
        <Header />
        {children}
        <Footer />
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
